export default function ({app, error}) {
  if (!app.$planHasPermission('manual_add_to_todo') || !app.$planHasPermission('crud_todo')) {
      return error({
        message: '権限がありません。',
        redirectPath: app.$redirectPathDefault(),
        redirectText: 'メインメニュー'
      });
  }
}